import { FaInstagram } from "react-icons/fa6";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { IconMapType, SkillsData, SocialLinksMapType } from "./types";
import { email } from "./personalInfo";
import hireupLogo from "../assets/images/hireup.png";
import optergyLogo from "../assets/images/optergy_logo.jpeg";
import codecampLogo from "../assets/images/codecamp.png";

const bg = "#0c0c0d";
const surface = "#151517";
const surfaceAlt = "#1c1c1f";
const accent = "#f5c518";
const muted = "#98999c";
const border = "rgba(255, 255, 255, 0.08)";

const roles = [
  "I'm a backend-first problem solver",
  "I'm a builder of accessible products",
  "I'm a cloud & CI/CD tinkerer",
];

const greetings = ["Hello", "Namaste", "Hola", "Bonjour", "Ciao", "Hallo"];

const IconMap: IconMapType = {
  instagram: FaInstagram,
  linkedIn: FaLinkedinIn,
  email: HiOutlineMail,
  github: FaGithub,
};

const SocialLinksMap: SocialLinksMapType = {
  instagram: "https://www.instagram.com/oneaman95/",
  linkedIn: "https://www.linkedin.com/in/amanshekhar995/",
  email: `mailto:${email}`,
  github: "https://github.com/amansh95",
};

const hireupInfo =
  "Hireup is an online platform that empowers people with disabilities to find, hire, and manage their own support workers. " +
  "As a platform designed to give users control over their support. " +
  "With a mission to revolutionize the disability support sector, Hireup fosters a community-driven approach to providing accessible, quality care.";

const hireup = {
  companyName: "Hireup",
  logo: hireupLogo,
  details: hireupInfo,
  websiteLink: "https://hireup.com.au/",
  colorGradient: "linear(to top, #0c0c0d, #10214d)",
  accentColor: "#2b3aff",
  // Hireup's site uses Inter for its wordmark/headings
  fontFamily: "'Inter', sans-serif",
  fontWeight: 700,
};

const optergyInfo =
  "Optergy is a building automation company specializing in smart solutions for managing and optimizing building performance. " +
  "Their technology integrates systems such as HVAC, lighting, energy management, and access control into a unified platform, allowing for enhanced efficiency, " +
  "comfort, and sustainability.";

const optergy = {
  companyName: "Optergy",
  logo: optergyLogo,
  details: optergyInfo,
  websiteLink: "https://optergy.com/",
  colorGradient: "linear(to top, #0c0c0d, #0e3d3a)",
  accentColor: "#1fbf9f",
  // Optergy's site uses Nunito Sans for its headings/wordmark
  fontFamily: "'Nunito Sans', sans-serif",
  fontWeight: 800,
};

const codecampInfo =
  "Code Camp is where parents find fun school holiday and after-school activities, " +
  "that empower your kids to design, code and create, and spark a passion, " +
  "so they can go and change the world with a smile on their face.";

const codecamp = {
  companyName: "Code Camp",
  logo: codecampLogo,
  details: codecampInfo,
  websiteLink: "https://www.codecamp.com.au/",
  colorGradient: "linear(to top, #0c0c0d, #0f2e4d)",
  accentColor: "#2fa4e7",
  // Code Camp's site uses a proprietary display font (Simian); Fredoka is a
  // freely licensed rounded/playful stand-in matching the same brand feel.
  fontFamily: "'Fredoka', sans-serif",
  fontWeight: 600,
};

const skillsData: SkillsData = {
  Languages: {
    category: "Languages",
    skills: [
      { name: "TypeScript", level: "Advanced" },
      { name: "JavaScript", level: "Advanced" },
      { name: "Java", level: "Advanced" },
      { name: "Python", level: "Intermediate" },
      { name: "Elixir", level: "Beginner" },
    ],
  },
  Frontend: {
    category: "Frontend",
    skills: [
      { name: "React", level: "Intermediate" },
      { name: "Next.js", level: "Intermediate" },
      { name: "Vue.js", level: "Intermediate" },
      { name: "Chakra UI", level: "Intermediate" },
      { name: "HTML5", level: "Advanced" },
      { name: "CSS3", level: "Advanced" },
    ],
  },
  Backend: {
    category: "Backend",
    skills: [
      { name: "Node.js", level: "Advanced" },
      { name: "Express.js", level: "Advanced" },
      { name: "Koa.js", level: "Intermediate" },
      { name: "Spring Boot", level: "Beginner" },
    ],
  },
  Databases: {
    category: "Databases",
    skills: [
      { name: "PostgreSQL" },
      { name: "MongoDB" },
      { name: "DynamoDB" },
      { name: "Redis" },
    ],
  },
  Infrastructure_as_Code: {
    category: "Infrastructure as Code",
    skills: [
      { name: "Terraform", level: "Advanced" },
      { name: "AWS CDK" },
      { name: "SSM" },
    ],
  },
  CI_CD: {
    category: "CI/CD & DevOps",
    skills: [
      { name: "Docker", level: "Advanced" },
      { name: "Buildkite", level: "Intermediate" },
      { name: "Octopus Deploy", level: "Intermediate" },
      { name: "GitHub Actions", level: "Intermediate" },
      { name: "Jenkins", level: "Intermediate" },
    ],
  },
  AI_Tools: {
    category: "AI Tools",
    skills: [
      { name: "Claude Code", level: "Advanced" },
      { name: "Cursor", level: "Intermediate" },
    ],
  },
};

export {
  IconMap,
  SocialLinksMap,
  hireup,
  optergy,
  codecamp,
  skillsData,
  roles,
  greetings,
  bg,
  surface,
  surfaceAlt,
  accent,
  muted,
  border,
};
